export const SignInStringTypes = {
  INVALID_EMAIL: "Please enter a valid email",
  NO_PASSWORD: "Please enter your password",
  INVALID_CREDENTIALS: "Incorrect username or password. Please try again.",
  FORGET_PASSWORD_SUCCESS_MSG:
    "Password recovery instruction has been sent to your email if it exist.",
};
